import './Footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <h3 className="footer__names">
        Вадим<span className="footer__ampersand">&</span>Дарья
      </h3>
      <div className="footer__divider"></div>
      <p className="footer__date">21.06.2026</p>
    </footer>
  );
};

export default Footer;
